/* Beauty Source — Quick Add op product cards
   Opent Symmetry's native cart drawer */
(function(){
  'use strict';

  if(window.__bsQuickAddInit) return;
  window.__bsQuickAddInit = true;

  var adding = {};

  /* Quick add handler */
  document.addEventListener('click', function(e){
    /* Quick add button */
    var btn = e.target.closest('.js-bs-quick-add');
    if(btn){
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var id = btn.getAttribute('data-variant-id');
      if(!id || adding[id]) return;
      adding[id] = true;

      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Toevoegen…';

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      })
      .then(function(r){
        if(!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function(){
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(r){ return r.json(); });
      })
      .then(function(cart){
        /* Cart counter updaten */
        document.querySelectorAll('.cart-link__count, [data-cart-count], .cart-count, .header__cart-count, .cart-link__bubble-num')
          .forEach(function(el){
            el.textContent = cart.item_count;
            if(cart.item_count > 0){
              el.classList.add('is-visible', 'has-items');
              el.style.display = '';
            }
          });

        /* Symmetry cart drawer openen */
        var drawer = document.querySelector('cart-drawer');
        if(drawer){
          var cartForm = drawer.querySelector('cart-form');
          if(cartForm && typeof cartForm.refresh === 'function'){
            cartForm.refresh();
          }
          if(typeof drawer.open === 'function'){
            drawer.open(document.querySelector('.cart-link'));
          }
        }

        btn.textContent = 'Toegevoegd ✓';
        setTimeout(function(){
          btn.textContent = original;
          btn.disabled = false;
          delete adding[id];
        }, 1200);
      })
      .catch(function(){
        btn.textContent = 'Probeer opnieuw';
        setTimeout(function(){
          btn.textContent = original;
          btn.disabled = false;
          delete adding[id];
        }, 1500);
      });
      return;
    }

    /* Card media klik — navigeer naar product */
    var media = e.target.closest('.bs-card__media');
    if(media){
      var productUrl = media.getAttribute('data-url');
      if(productUrl) window.location.href = productUrl;
    }
  });

})();